import { createContext, useContext, Dispatch, SetStateAction } from 'react';
import { MapData } from '../Types/types';

export const defaultMapData: MapData = {
    isClusteringMode: true,
    riders: [],
    drivers: [],
};

export type MapDataContextType = {
    mapData: MapData;
    setMapData: Dispatch<SetStateAction<MapData>>;
};

export const MapDataContext = createContext<MapDataContextType>({
    mapData: defaultMapData,
    setMapData: () => {},
});

export const useMapTaxiBusinessData = () => {
    return useContext(MapDataContext);
};
